/**
 * Client for AI Look Match (server/modules/ai). The server holds the model key;
 * the browser sends downscaled images and the current look-field values and
 * gets back proposed values, already clamped to each field's band — which the
 * editor clamps AGAIN before applying (see basic/applyEngine.ts setValues).
 */
import { apiGet, apiPost } from "../shared/apiClient";
import type { LookCategory } from "../../shared/lookFields";

export interface LookImagePayload {
  mediaType: "image/jpeg" | "image/png" | "image/webp";
  /** Plain base64, no `data:` prefix. */
  data: string;
}

export interface LookMatchRequest {
  references: LookImagePayload[];
  current?: LookImagePayload;
  categories: LookCategory[];
  note?: string;
  values: Record<string, number | boolean | string | null>;
}

export interface LookMatchChange {
  key: string;
  value: number | boolean | string | null;
  reason: string;
}

export interface LookMatchResponse {
  summary: string;
  changes: LookMatchChange[];
  dropped: number;
  model: string;
}

export const getLookMatchStatus = () => apiGet<{ lookMatch: boolean; model: string }>("/ai/status");

export const requestLookMatch = (body: LookMatchRequest) => apiPost<LookMatchResponse>("/ai/look-match", body);
